import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateCopyBudget = async ({
  communityId,
  budgetId,
  data,
}: {
  communityId: string;
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${BUDGET(communityId)}/${budgetId}/copy`,
    data
  );
};

const useCopyBudgetMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateCopyBudget,
    ...queryParams,
  });

export default useCopyBudgetMutation;